export const ACA_REPORTING = {
    HEADER: 'Affordable Care Act (ACA) Reporting Hub',
    INFO_BOXES: [
        {
            STATUS: 'new',
            SUBHEADING: 'ACA Reporting Questionnaire',
            DESCRIPTION:
                'The ACA Reporting Questionnaire establishes the initial information required to access the ACA reporting tool.',
            BROKER_ACCESS: {
                DESCRIPTION:
                    'The ACA Reporting Questionnaire establishes the initial information required to set up and allow access to the ACA Reporting Tool.',
                NOTE_TITLE: 'NOTE:',
                NOTE_DESCRIPTION:
                    'To grant access to a Third Party, you must first complete question number one in this questionnaire.',
            },
            LINK_TEXT: 'Get Started',
            ACTION: 'consent',
        },
        {
            STATUS: 'draft',
            SUBHEADING: 'ACA Reporting Questionnaire',
            DESCRIPTION:
                'The ACA Reporting Questionnaire establishes the initial information required to access the ACA reporting tool.',
            BROKER_ACCESS: {
                DESCRIPTION:
                    'The ACA Reporting Questionnaire establishes the initial information required to set up and allow access to the ACA Reporting Tool.',
                NOTE_TITLE: 'NOTE:',
                NOTE_DESCRIPTION:
                    'To grant access to a Third Party, you must first complete question number one in this questionnaire.',
            },
            LINK_TEXT: 'Edit',
            ACTION: 'consent',
        },
        {
            STATUS: 'submitted',
            SUBHEADING: 'ACA Reporting Questionnaire',
            DESCRIPTION:
                'The ACA Reporting Questionnaire establishes the initial information required to access the ACA reporting tool.',
            BROKER_ACCESS: {
                DESCRIPTION:
                    'The ACA Reporting Questionnaire establishes the initial information required to set up and allow access to the ACA Reporting Tool.',
                NOTE_TITLE: 'NOTE:',
                NOTE_DESCRIPTION:
                    'To grant access to a Third Party, you must first complete question number one in this questionnaire.',
            },
            LINK_TEXT: 'View',
            ACTION: 'summary',
            UNLOCK_LINK_TEXT: 'Unlock Questionnaire',
        },
        {
            STATUS: 'submitted',
            SUBHEADING: 'ACA Reporting Tool',
            DESCRIPTION:
                'The ACA Reporting Tool allows the users designated from the ACA Reporting Questionnaire to access IRS Forms 1094 and 1095 and electronically transmit your filing to the IRS to complete your ACA filing requirements.',
            BROKER_ACCESS: {
                DESCRIPTION:
                    'The ACA Reporting Tool allows users to create, distribute, and electronically transmit ACA returns (Forms 1094-B/C and 1095 B/C) to the IRS (and certain states with healthcare reporting mandates) to fulfill ACA reporting requirements. ',
            },
            LINK_TEXT: 'Get Started',
            ACTION: 'HRLogics',
        },
    ],
    HR_TOOLS: 'hrTools',
    HOME: 'home',
    ACA_REPORTING_HUB: 'acaReportingHub',
    TAX_YEARS: 'taxYears',
    QUESTIONNAIRE_HEADER: 'Affordable Care Act (ACA) Reporting Questionnaire',
    QUESTIONNAIRE: {
        PREVIOUS: 'Previous',
        NEXT: 'Next',
        DONE: 'Done',
        EDIT: 'Edit',
        SUBMIT: 'Submit',
        HELP_TEXT:
            'To receive assistance from our HR and Compliance Experts or for technical issues, click the Get Help button below.',
    },
    COMPLETE: 'Complete',
    ANSWER_TYPES: {
        LIST: 'list',
        RADIO: 'radio',
        CHECKBOX: 'checkbox',
        TEXT: 'text',
    },
    UNLOCK_CONFIRMATION_MSG: 'Are you sure you want to unlock this questionnaire?',
    CONFIRMATION_MSG:
        'Your ACA Questionnaire has been submitted and is currently locked. Please contact an administrator if you need to make changes.',
    UNLOCKED_SUCCESSFULLY_MSG: 'ACA Questionnaire unlocked successfully',
    SUMMARY_TEXT: {
        UNSAVED_SUMMARY:
            'Thank you for completing the ACA Reporting Questionnaire. To make changes, click “Edit” or click “Submit” to finish. Upon submission, you will be redirected to the ACA Reporting Hub. The next step is to access the ACA Reporting Tool. Visit the Help Center to download the ACA Reporting B or C Series User Guide.',
        SAVED_SUMMARY:
            'Thank you for completing the ACA Reporting Questionnaire. Click “Done” to finish. Upon submission, you will be redirected to the ACA Reporting Hub.  The next step is to access the ACA Reporting Tool. Visit the Help Center to download the ACA Reporting B or C Series User Guide.',
        PARTNER_ADMIN: {
            PARTIALLY_COMPLETED:
                "The client has only partially completed the ACA Reporting Questionnaire. As a result, only the section they've completed will be visible to the broker agent. Incomplete sections will remain hidden until the client completes them.",
            FULLY_COMPLETED:
                'The ACA Reporting Questionnaire has been successfully submitted. Access the ACA Reporting Tool to begin your filing process. For guidance, visit the Help Center to download the appropriate ACA Reporting B or C Series User Guide.',
        },
    },
    TAX_YEAR: 'Tax Year',
    REVIEW_TAX_YEAR: 'Review All Tax Years',
    ALL_TAX_YEARS: 'All Tax Years',
    SUBMITTED_BY: 'Submitted By',
    SUBMISSION_DATE: 'Submission Date',
    CHANGE_NOTIFICATION:
        'It appears that you have submitted your questionnaire multiple times. Please allow us 24 hours to update the data based on your latest responses. In the meantime, you will continue to see your previous data.',
    CONSENTED_SUCCESSFULLY_MSG:
        'An invitation, granting access to your ACA Reporting Hub, has been sent to your Third-Party Assister for the ${year} tax year.',
    REVOKED_SUCCESSFULLY_MSG:
        'Broker access has been successfully canceled. The broker no longer has access to your ACA Report',
};

export const QUESTIONNAIRE_STATUSES = {
    NEW: 'new',
    DRAFT: 'draft',
    SUBMITTED: 'submitted',
};

export const QUESTIONNAIRE_STEPS = {
    CONSENT: 'consent',
    SUMMARY: 'summary',
};

export const QUESTIONNAIRE_MODAL = {
    HEADING: 'Consent Required',
    QUESTIONNAIRE_V1: {
        DESCRIPTION:
            'To continue with the ACA Reporting Questionnaire, you must consent to proceed. Select Exit to ACA Reporting Tool to return to the main ACA Reporting tool page.',
        SECONDARY_BUTTON_TEXT: 'Exit to ACA Reporting Tool',
        PRIMARY_BUTTON_TEXT: 'I Understand',
    },
    QUESTIONNAIRE_V2: {
        DESCRIPTION:
            'To continue with the ACA Reporting Questionnaire, you must consent to proceed. To consent, select the Previous button. To confirm your selection "I do not consent" select the Decline and Exit button.',
        SECONDARY_BUTTON_TEXT: 'Decline and Exit',
        PRIMARY_BUTTON_TEXT: 'Previous',
    },
};

export const ACA_REPORTING_TOOL = {
    HR_LOGICS: 'HRLogics',
};

export const ANSWER_LIST_INPUT = {
    HEADER_LIST: {
        BUSINESS_NAME: 'Legal Business Name',
        FEDERAL_TAX_ID: 'Federal Tax ID #',
        FEDERAL_TAX_ID_HEADING: 'Federal Tax ID Number',

        PARENT_CHILD_COMPANY: 'Parent or Child Company',
        COMPANY: {
            PARENT: 'Parent Company',
            CHILD: 'Child Company',
        },
        BUTTONS: {
            DELETE: 'Delete',
            ADD_COMPANY: 'Add Company',
        },
    },
    MAX_COUNT_LIMIT: 30,
    ERROR: 'Nine digits required',
    ONLY_SPACES: 'Sorry, only spaces are not allowed.',
    MAX_LIMIT_ERROR: 'A maximum of 30 businesses can be added.',
};

export const LIST_INPUT_ERROR_MESSAGE = {
    MAX_CHAR_LIMIT: 'Should NOT be longer than 150 characters.',
    LEADING_SPACES: 'Sorry, only spaces are not allowed',
    ALLOWED_CHAR:
        "Make sure you use only letters, numbers, spaces, and these characters: - & ' , ( )",
};

export const MANAGE_QUESTIONNAIRE = {
    TITLE: 'Manage Questionnaire',
    CAPTION: 'Choose A Company',
};

export const ACA_GRANT_BROKER_ACCESS = {
    TITLE: 'Grant Third-Party Access',
    TOOLTIP_CONTENT: 'Granting your broker access allows them to review your ACA Report.',
    BROKER_DETAILS: {
        BUSINESS_NAME: 'Business Name',
        ACCESS_STATUS: 'Access Status',
        START_DATE: 'Start Date',
        END_DATE: 'End Date',
        TAX_YEAR: 'Tax Year',
    },
    BUTTONS: {
        GRANT_ACCESS: 'Grant Access',
        REVOKE_ACCESS: 'Revoke Access',
    },
    STATUS: {
        PENDING: 'pending',
        ACCEPTED: 'accepted',
        DECLINED: 'declined',
        REVOKED: 'revoked',
    },
    REVOKE_ACCESS_TITLE: 'Revoke Broker Access',
    REVOKE_ACCESS_MSG:
        'Cancelling your broker’s access will revoke their ability to view your ACA Report. Select Revoke to proceed or Cancel to keep their access status.',
    GRANT_ACCESS_DISCLAIMER:
        '*The grant access feature is only available between January 1 and April 30.',
};

export const ACA_HELP_CENTER = {
    TITLE: 'Help Center',
    LINKS: [
        {
            LINK_ID: 'helpCard_link_1',
            LINK_TEXT:
                "<a href='/help-center/aca-reporting-hub' target='_blank'>ACA Reporting Hub User Guides and Resources</a>",
        },
        {
            LINK_ID: 'helpCard_link_2',
            LINK_TEXT:
                "<a href='/help-center/aca-reporting-hub/quick-reference/ab273986-6c04-a6cc-0930-669501724035/details' target='_blank'>ACA Reporting Questionnaire Instruction Guide</a>",
        },
        {
            LINK_ID: 'helpCard_link_3',
            LINK_TEXT:
                "<a href='/help-center/aca-reporting-hub/videos/01607448-7c8c-028e-ffac-fdfbcb201bb2/details' target='_blank'>ACA Reporting Video Demonstration for B-Series</a>",
        },
        {
            LINK_ID: 'helpCard_link_4',
            LINK_TEXT:
                "<a href='/resources/webinars/6ymr1mosfkHsKcFQly2nAU/details' target='_blank'>ACA Reporting Video Demonstration for C-Series</a>",
        },
        {
            LINK_ID: 'helpCard_link_5',
            LINK_TEXT:
                "<a href='/help-center/aca-reporting-hub/quick-reference/ec8e8fad-0a09-d19d-62a9-a38736218e82/details' target='_blank'>ACA Granting Others Access Instruction Guide</a>",
        },
    ],
};

export const TAX_YEAR_LINKS = {
    [QUESTIONNAIRE_STATUSES.NEW]: {
        ...ACA_REPORTING.INFO_BOXES[0],
    },
    [QUESTIONNAIRE_STATUSES.DRAFT]: {
        ...ACA_REPORTING.INFO_BOXES[1],
    },
    [QUESTIONNAIRE_STATUSES.SUBMITTED]: {
        ...ACA_REPORTING.INFO_BOXES[2],
    },
    SELECT: 'Select',
};

export const ROUTE_CRUMBS = {
    MANAGED_QUESTIONNAIRE: '/hr-tools/aca-reporting/managed-questionnaire',
    TAX_YEARS: '/hr-tools/aca-reporting/tax-years',
    INFO: '/hr-tools/aca-reporting/info',
    DASHBOARD: '/dashboard',
};

export const MANAGED_ACA_REPORT_ACCESS = {
    TITLE: 'Manage ACA Report Access',
    DESCRIPTION:
        'Select a company to access and manage its ACA Reporting Hub, provided that the company has granted you access.',
    LIST: {
        COLUMNS: {
            ACCESS_STATUS: 'Access Status',
            ACTIONS: 'Actions',
        },
        ACCESS_STATUS: {
            TOOLTIP_CONTENT: 'Accepting the invitation will change your status to "Active".',
        },
    },
    ACCESS_STATUS: {
        ACTIVE: 'Active',
        PENDING: 'Pending',
    },
    ACTIONS: {
        ACCEPT: 'Accept',
        DECLINE: 'Decline',
        VIEW: 'View',
    },
    SEARCH: {
        PLACEHOLDER: {
            COMPANY_NAME: 'Search by Company Name',
            USERS: 'Search Users',
        },
    },
    CONSENT_STATUS_LABEL: {
        ALL: 'All',
        ACCEPTED: 'Accepted',
        PENDING: 'Pending',
    },
    CONSENT_STATUS_VALUE: {
        ALL: 'all',
        ACCEPTED: 'accepted',
        PENDING: 'pending',
    },
    ACCEPT_MODAL: {
        TITLE: 'Accept ACA Report Invite',
        DESCRIPTION: 'Once accepted, you will have access to ${clientCompanyName} ACA Report.',
        BUTTONS: {
            ACCEPT: 'Accept',
            CANCEL: 'Cancel',
        },
    },
    DECLINE_MODAL: {
        TITLE: 'Decline ACA Report Invite',
        DESCRIPTION:
            'Once declined, you will not have access to ${clientCompanyName} ACA Report. This cannot be undone. To gain access, the client must send another invitation granting you access to their ACA Report.',
        BUTTONS: {
            DECLINE: 'Decline',
            CANCEL: 'Cancel',
        },
    },
};

export const FEIN_MODAL = {
    PROSPECT_PARTNER_ADMIN_TITLE: 'Action Needed',
    TITLE: 'FEIN Required',
    ACA: {
        PROSPECT_PARTNER_ADMIN_DESCRIPTION:
            'A Federal Employer Identification Number (FEIN) is required for this company before accessing the ACA Reporting Tool.<br>' +
            'Please contact your client’s administrator to add the FEIN through the company profile.',
        DESCRIPTION:
            'Please click the edit company page below to update the FEIN. Once updated, return to the ACA Reporting Hub to continue.',
    },
    PCORI: {
        PROSPECT_PARTNER_ADMIN_DESCRIPTION:
            'A Federal Employer Identification Number (FEIN) is required for this company before accessing the PCORI Reporting Tool.<br>' +
            'Please contact your client’s administrator to add the FEIN through the company profile.',
        DESCRIPTION:
            'Please click the edit company page below to update the FEIN. Once updated, return to the PCORI Reporting to continue.',
    },
    BUTTONS: {
        UPDATE: 'Update FEIN',
        CANCEL: 'Cancel',
        OK: 'OK',
    },
};

export const PROGRESS_BAR = {
    OFFSET: {
        END: 8.4,
        OTHER: 7.8,
    },
};

export const QUESTIONNAIRE_VERSIONS = {
    VERSION_ONE: 'v1',
    VERSION_TWO: 'v2',
};

export const ANSWER_CARD_INPUT = {
    PLACEHOLDER_CONTAINER: {
        FIRST_PART: "You haven't added a business yet. Click the",
        HIGHLIGHT_TEXT: '"Add Business"',
        SECOND_PART: 'button to get started.',
    },
    BUTTON_TEXT: 'Add Business',
};

export const DELETE_BUSINESS_MODAL = {
    DESCRIPTION: 'Are you sure you want to delete ${businessName}? This action cannot be undone.',
    BUTTONS: {
        DELETE: 'Delete',
        CANCEL: 'Cancel',
    },
};

export const ACA_REPORT_ACCESS_TAB = {
    MANAGE: {
        ID: 'manage',
        LABEL: 'Manage ACA Report Access',
    },
    COMPANIES: {
        ID: 'companies',
        LABEL: 'Companies',
    },
    USERS: {
        ID: 'users',
        LABEL: 'Users',
    },
    COLUMN_TITLE: {
        PARTNER_NAME: 'Partner Name',
        PARTNER: 'Partner',
    },
};

export const REDIS_VALUE = {
    ACA: 'ACA',
    PCORI: 'PCORI',
};

export const SSO_SECONDARY_ACCOUNT = {
    TOOLTIP_MESSAGE: 'You cannot perform SSO for non-primary client companies.',
};
